import { FCX, Loader as PlatformLoader } from "@datassential/platform-ui-lib";
import cn from "classnames";

const Loader: FCX = ({
    className,
    children,
    ...props
}) => {
    return (
        <PlatformLoader
            className={cn(
                "Loader",
                "appears",
                "fast",
                className,
            )}
            {...props}
        >
            {children}
        </PlatformLoader>
    );
};

export default Loader; 